import { render, staticRenderFns } from "./SmartDetailDrawer.vue?vue&type=template&id=623ba230"
import script from "./SmartDetailDrawer.vue?vue&type=script&lang=ts"
export * from "./SmartDetailDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports